import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";

import Divider from "../../../utilities/Divider/Divider";
import {Filters, SessionFiltersContainer} from "../../conteiners/filters/Filter.hoc";
import HiddenContainer from "../../conteiners/hiddenContainer/HiddenContainer";
import ReactTable from "../../conteiners/ReactTable";
import withTabs from "../../conteiners/tabs/Tabs.hoc";
import {DateInput, Select, TextInput} from "../../Inputs";
import {LOGIST_WINDOW_TYPES} from "../../Logist/common/constants";
import useLogistFilters from "../../Logist/common/LogistFilters/useLogistFilters";
import {fetchStockPoolFilters} from "../../Logist/redux/operations";
import useColumns from "../../Requests/OrderProcessing/utils/hooks/useColumns";

import {PLANNING_TABLE_COLUMNS, REQUEST_TABLE_COLUMNS} from "./constants";
import PlanningDetailsPanel from "./PlanningDetailsPanel";

const FILTERS_WINDOW = "WAREHOUSE_REQUESTS_FOR_PLANNING";

const ReqForPlanningRegisterWarehouse = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [arePlanningDetailsShown, setPlanningDetailsShown] = useState(false);
  const {coManagersOptions, feaManagersOptions, logistOptions} = useLogistFilters();

  const planningTableColumns = useColumns(PLANNING_TABLE_COLUMNS);
  const requestTableColumns = useColumns(REQUEST_TABLE_COLUMNS);

  useEffect(() => {
    dispatch(fetchStockPoolFilters({window: LOGIST_WINDOW_TYPES.WAREHOUSE}));
  }, []);

  return (
    <div className="fcCol aistr fGrow w100 h100" style={{minHeight: 0}}>
      <SessionFiltersContainer window={FILTERS_WINDOW}>
        <Filters>
          <div className="f_block fGrow w100 pt0_5">
            <TextInput label="TP №" name="cargoNumber" width="12rem" />
            <TextInput label="SP №" name="stockPoolNumber" width="12rem" />
            <Select label="Logist" name="managerLogistId" options={logistOptions} width="12rem" />
            <TextInput label="Request №" name="requestNumber" width="12rem" />
            <Select label="CO Manager" name="managerCoId" options={coManagersOptions} width="12rem" />
            <TextInput label="Notes" name="note" width="12rem" />
            <Select label="FEA Manager" name="managerFeaId" options={feaManagersOptions} width="12rem" />
          </div>

          <div className="period-wrapper noShrink pt0_5">
            <span>{t("d period")}</span>
            <div className="request-date-wrapper">
              <DateInput label="From" name="dateStart" />
              <DateInput label="To" name="dateEnd" />
            </div>
          </div>
        </Filters>
      </SessionFiltersContainer>

      <Divider />

      <div className="fdr fGrow w100 maxH100" style={{minHeight: 0}}>
        <div className="fcCol aistr fGrow h100" style={{minHeight: 0, minWidth: 0}}>
          <ReactTable
            columns={planningTableColumns}
            defaultData={[]}
            className="w100 scrollX"
            style={{flex: "3 1 0", minHeight: 0}}
            enableColumnResizing
            selectable={false}
          />

          <Divider className="noShrink" />

          <ReactTable
            columns={requestTableColumns}
            defaultData={[]}
            className="w100 scrollX"
            style={{flex: "2 1 0", minHeight: 0}}
            enableColumnResizing
            selectable={false}
          />
        </div>

        <HiddenContainer
          vertical
          isShown={arePlanningDetailsShown}
          setIsShown={setPlanningDetailsShown}
          tooltipMessageShow="Show planning details"
          tooltipMessageHide="Hide planning details"
          className="h100 maxH100 noShrink"
          contentClassName="h100 w100"
          style={{
            width: "73%",
            flex: arePlanningDetailsShown ? "0 0 73%" : "0 0 0",
            minWidth: 0,
            backgroundColor: "white",
          }}
        >
          <PlanningDetailsPanel />
        </HiddenContainer>
      </div>
    </div>
  );
};

export default withTabs({label: "Request Register for planning"})(ReqForPlanningRegisterWarehouse);
